import {
  borderRadiusMd,
  borderWidthHairline,
  colorInterfaceLightDown,
  colorInterfaceLightPure,
  spacingInlineSm,
  spacingInlineXs,
  spacingInlineXxs,
} from '@useblu/ocean-tokens/web/tokens';
import styled from 'styled-components';

export const ListOption = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${spacingInlineXs};
`;

export const Option = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  padding: ${spacingInlineXs};

  border: ${borderWidthHairline} solid ${colorInterfaceLightDown};
  border-radius: ${borderRadiusMd};

  & .ods-radio__root {
    padding: 0;

    &:hover {
      background-color: transparent;
    }
  }

  & img {
    width: 40px;
    height: 20px;

    object-fit: contain;
  }
`;

export const OptionContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  gap: ${spacingInlineXxs};
`;

export const DrawerContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  gap: ${spacingInlineXs};
  padding: 0 ${spacingInlineSm};
  height: 100%;
  overflow-y: auto;
  padding-bottom: 115px;
`;

export const DrawerAction = styled.div`
  position: absolute;

  width: calc(100% - ${spacingInlineXs} * 2);
  bottom: 0;
  left: 0;
  padding: ${spacingInlineSm} ${spacingInlineXs};
  background-color: ${colorInterfaceLightPure};

  border-top: ${borderWidthHairline} solid ${colorInterfaceLightDown};

  & .ods-btn {
    width: 100%;
  }
`;
